import { useQuery, UseQueryResult } from 'react-query'
import { API } from 'core/requests'
import { EmployeeType } from 'types'

export const useFetchEmployees = (): UseQueryResult<EmployeeType[], Error> => {
  return useQuery('employees', () => API.get('employees'))
}
